import { AxiosError, AxiosResponse } from "axios"
import api from "../../../data/api"
import { Dispatch } from "react"
import { IsmagCriteriaAction, IsmagCountry } from "./reducer"
import { prepareError, prepareErrorFromArray } from "../../../utils/error"
import { OptionCl } from "../../../components/select-cl"
import { IsmagAction } from "../results/reducer"
import {SearchHistoryAction} from "../../../components/app/reducer"
import { objectFormData } from "../../../utils/formdata"
import { Ismag } from "../../../openapi/ismag/api"

const prepareCountries = (response: IsmagCountry[]) => {
    const opts: OptionCl[] = response.map((ctry: IsmagCountry) => ({
        id: ctry.ctryIsoCode,
        description: ctry.ctryIsoCode + " - " + ctry.ctryName
    })
    )
    return opts;
}


// countries for the dropdown
export const fetchCountries = (
    dispatch: Dispatch<IsmagCriteriaAction>
    ) => {
          //console.log("ismag criteria service getting data from /countries")
        api
        .post("/codelist/v1/ISMAG/ismagcountries")
        .then((response: AxiosResponse) => {
            if (response.data === "") {
                dispatch({ type: "IsmagCriteria/FETCHERROR", payload: "Error when obtaining data from the DB. Contact Production Support." })
            } else {
                //console.log("ismag criteria service: got data " + JSON.stringify(response))
                const countries: IsmagCountry[] = response.data;
                dispatch({ type: "IsmagCriteria/COUNTRIESLOADED", payload: prepareCountries(countries) })
            }
        }).catch((error: AxiosError) => {
            dispatch({ type: "IsmagCriteria/FETCHERROR", payload: prepareError(error) })
        })
}



// search for ismag issuers
export const fetchIsmagIssuers = (
    dispatch: Dispatch<IsmagAction>,
    dispatchHistory: Dispatch<SearchHistoryAction>,
    data: FormData ,
    ismagSearchHistory: Object   
) => {
    //console.log("Ismag criteria service search for issuers using params")
    //alert("Searching:" + stringifyFormData( data));
    console.log("sending data " + JSON.stringify(objectFormData(data)))
    // {
    //     headers: {"Content-Type":"application/json; charset=utf-8"}
    // }
    dispatchHistory({type: "SearchHistory", searchHistory: ismagSearchHistory});
    api
        .post("/codelist/v1/ISMAG/search", objectFormData(data))
        .then((response: AxiosResponse) => {

            if (response.data.result && response.data.result === "ERROR") {
                dispatch({ type: "Ismag/FETCHERROR", payload: prepareErrorFromArray(response.data.errorMessage, "Error") })
            } else if (response.data.result && response.data.result === "REJECTED") {
                dispatch({ type: "Ismag/FETCHERROR", payload: "For selected search criteria no data has been found." })
            } else {
                console.log("ismag query service: got data " + JSON.stringify(response))
                const ismags: Ismag[] = response.data.ismag;
                dispatch({ type: "Ismag/SEARCHDONE", payload: ismags, searchCriteria: data });
                dispatch({ type: "Ismag/FETCHERROR", payload: "" });                
            }
        }).catch((error: AxiosError) => {
            dispatch({ type: "Ismag/FETCHERROR", payload: prepareError(error) })
        })





    // const dummyIssuers : Ismag[] = [{ adherence:"a", ctry: "b", issuerName:"c"},{ adherence:"def", ctry: "back", issuerName:"cyril"},{
    //     adherence : "YES",
    //     ctry : "CZ",
    //     issuerName: "This is not the Issuer you're looking for"
    // }]

    // dispatch({type: "Ismag/SEARCHDONE", payload: dummyIssuers } )
}
